<p class="song-style" id=song-desc>
<div><span s>Десять звёзд.</span></div>
<div><span>
  </span><span>Арон Крупп Игорю Коваленко</span></div>
<pre>
      <span><br>Есть десяток звёзд над головой <br>И топор, чтоб нарубить дрова.
      <br>Так сложи рюкзак, ведь это не впервой <br>Слышать нам разумные слова
      <br>О том, что лес вблизи не голубой. <br>Но нам дороже ртутных фонарей <br>Вот эти десять звёзд над головой. <br>
      <br>Но нам дороже ртутных фонарей <br>Вот эти десять звёзд над головой. </span>
  </pre>
<pre>
          <span><br>Эти десять звёзд - как маяки <br>На краю неведомой земли.
               <br>Нам нельзя, чтоб наши рюкзаки <br>Где-то дома прятались в пыли. <br>
               <br>Ведь нам нельзя привычкой обрастать <br>И тешить полуправдами себя.
                <br>Сумей без сожаленья оставлять | <br>Всё то, что держит у дверей тебя. | <b>2</b> раза </span>
              </pre>
<pre>
                  <span>
                  <br>Лижет красным языком костёр
  Чёрные ночные небеса, <br>И плывут над зеркалом озёр <br>Белого тумана паруса.
                  <br>А наши песни слушают леса, <br>И в чащу леса прячется беда.
                  <br>Приходят к нам из сказок чудеса | <br>В брезентовые наши города. <b>2</b> раза
                  </span>
              </pre>
<pre><span>
                  Лето <b>1964</b></span></pre>
